<!--<div class="only-read-metadata-data-div">-->
<!--  <span class="text-content" [title]="value">{{value ? value: ''}}</span>-->
<!--  <button mat-icon-button (click)="openDialog()" *ngIf="value && value.length > 19">-->
<!--    <mat-icon>visibility</mat-icon>-->
<!--  </button>-->
<!--</div>-->

<mat-expansion-panel [disabled]="!value||(value&&value.length<25)" [hideToggle]="panelHeader._isExpanded()"
                     class="custom-expansion" style="margin-bottom: 20px;">
  <mat-expansion-panel-header #panelHeader expandedHeight="0px">
    <span>{{panelHeader._isExpanded() ? '' : value}}</span>
  </mat-expansion-panel-header>
  <div class="expanded-div" (click)="panelHeader._toggle()">
<!--    <p>{{value}}</p>-->
    <p>{{!panelHeader._isExpanded() ? '' : value}}</p>
    <mat-icon>expand_less</mat-icon>
  </div>
</mat-expansion-panel>
